import { store } from "../store/index";
import {
  deleteAccountLink,
  filterAccountAdm,
  listAccountToExport,
  deleteManyAccountLink,
} from "../store/actions/AccountLinkActions";

/**
 * List items
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterAccountAdm(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const deleteAccount = async (uuid) => {
  const result = await store.dispatch(deleteAccountLink([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const deleteManyAccount = async (data) => {
  const obj = {
    uuids: data,
  };
  const result = await store.dispatch(deleteManyAccountLink(obj));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

/**
 * List order
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listAccountToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
